import * as z from 'zod';
import { logError } from '../../logging/log-error.helper';
export function getTypedTrackCustom(schemas, trackCustom) {
    function trackCustomEvent(event, data) {
        return trackCustom(event, data, schemas[event]);
    }
    return trackCustomEvent;
}
export function getCustomEvent(_a) {
    var data = _a.data, type = _a.type, schema = _a.schema;
    try {
        return schema.parse(data);
    }
    catch (error) {
        logError({
            error: error,
            message: "Validation failed for event: ".concat(type),
            tag: {
                name: 'type-validation',
                value: 'failed',
            },
            level: 'error',
            metadata: {
                event: type,
                data: data,
                validationError: error instanceof z.ZodError ? error.issues : null,
            },
        });
    }
}
